/* eslint-disable */
import React, { useContext, useState, useEffect } from 'react';
import { Button } from '@futura-library/ui-library';
import { efecty, priceCheck } from '../../../../../../assets/images/Global';
import styles from '../../MethodsFlow.module.css';
import data from '../../data';
import axiosPost from '../../../../../../methods/cashPayments/mx/axiosPost';
import ThankYouContext from '../../../../../../context/ThankYou/Context';
import PaymentContext from '../../../../../../context/Payment/Context';
import ProductContext from '../../../../../../context/Product/Context';
import GlobalContext from '../../../../../../context/Global/Context';
import organizeDataPayments from '../../../../../../methods/organizeDataPayments';
import AlertModal from '../../../../../AlertModal';
import { axiosPutRecalculateCarts } from '../../../../../../methods/products/axiosPut';
import { areThereCartsWithoutEnoughStock } from '../../../../../../utils/stock';
import totalPriceCarts from '../../../../../../hooks/totalCarts';
import sendFreshpaintEvent from '../../../../../../utils/sendFreshpaintEvent';
import { availableCountries } from '../../../../../../utils/locale';

// MercadoPago allows Efecty up to 8,000,000 COP on this account (payment_methods API) but its
// antifraud has rejected ~3.8M tickets (rejected_high_risk), so we cap lower; keep the copy in data.js in sync
const EFECTY_MAX_AMOUNT_COP = 5000000;

const FlowEfecty = () => {
  const paymentContext = useContext(PaymentContext);
  const thankYouContext = useContext(ThankYouContext);
  const productContext = useContext(ProductContext);
  const globalContext = useContext(GlobalContext);
  const [loadingEfectyButton, setLoadingEfectyButton] = useState(false);
  const [preventModal, setPreventModal] = useState(false);
  const { titleEfecty, descriptionEfecty, stepsEfecty, buttonEfecty, capEfecty } =
    data.efecty;
  const {
    country,
    name,
    email,
    customerId,
    publicKey,
    origin,
    setEmptyAddressFunction,
  } = globalContext;
  const { setDataEfecty } = thankYouContext;
  const { hasAddress } = paymentContext;
  const {
    carts: cartsProducts,
    couponsCode,
    productsWithDiscount,
    order,
  } = productContext;
  let dataToEfecty = organizeDataPayments();
  const totalPrice = totalPriceCarts(cartsProducts, false, order);
  const disableButton = totalPrice > EFECTY_MAX_AMOUNT_COP;
  const carts = new URLSearchParams(window.location.search).getAll('cart');
  const buttonUrl = new URLSearchParams(window.location.search).get(
    'redirectUrl'
  );
  const outOfStockModal = {
    title: '¡Lo sentimos!',
    description:
      'Uno de los productos de tu carrito ya no está disponible. Regresa a la tienda y vuelve a hacer tu selección.',
    button: 'Regresar a la tienda',
    imgAlert: priceCheck,
    urlRedirect: buttonUrl,
    discardLink: buttonUrl,
  };

  const dataToFreshpaint = {
    customer_id: customerId,
    distinct_id: customerId,
    product_id: cartsProducts[0]?.lineItems[0]?.id,
    cart_id: cartsProducts[0]?.id,
    product_quantity: cartsProducts[0]?.lineItems.length,
    public_key: publicKey,
    country_ops: country,
    currency: availableCountries[country.toLocaleLowerCase()].currency,
    payment_method: 'efecty',
    product_category: 'appointment',
    product: `appointment-${country.toLocaleLowerCase()}`,
    payment_type: 'Complete',
    platform: 'checkout_futura',
    transaction_amount: cartsProducts[0]?.totalPrice.centAmount / 100,
    name,
    email,
  };

  useEffect(() => {
    if (productsWithDiscount.length !== 0) {
      const productsArray = [];

      productsWithDiscount.forEach((product) => {
        const { images } = product.variant;
        const { centAmount } = product.price.value;
        const productsConvert = {
          id: product.id,
          productId: product.productId,
          name: 'es-CO',
          price:
            product?.discountedPricePerQuantity[0]?.discountedPrice?.value
              .centAmount,
          quantity: product.quantity,
          totalPrice: centAmount * product.quantity,
          images,
        };
        productsArray.push(productsConvert);
      });

      dataToEfecty.cartData.totalLineItemQuantity = productsArray.length;
      dataToEfecty.cartData.lineItems = productsArray;
    }
  }, [couponsCode]);

  const getEfectyReference = () => {
    /*if (!hasAddress) {
      setEmptyAddressFunction(true);
      window.scrollTo({ top: 0, behavior: 'smooth' });
      return;
    }*/

    (async () => {
      try {
        const { data: upToDateCartData } = await axiosPutRecalculateCarts(
          carts
        );

        if (areThereCartsWithoutEnoughStock(upToDateCartData.carts)) {
          setPreventModal(true);
        } else {
          setPreventModal(false);

          dataToEfecty.country = 'Colombia';
          dataToEfecty.discountPrice = couponsCode.length > 0 ? true : false;
          dataToEfecty.paymentMethodType = 'efecty';
          dataToEfecty.transactionType = 'product';
          dataToEfecty.productKeyName =
            cartsProducts[0]?.lineItems[0]?.productKey;
          dataToEfecty.origin = origin;

          setLoadingEfectyButton(true);
          axiosPost(dataToEfecty)
            .then((res) => {
              dataToFreshpaint.attempted_status = true;
              if (origin === 'appointmentv2') {
                sendFreshpaintEvent(
                  'New Checkout - Payment Attempted',
                  dataToFreshpaint
                );
              }
              setDataEfecty(res.data);
              setLoadingEfectyButton(false);
              window.location.replace(res.data.mercadoPagoLink);
            })
            .catch(() => {
              dataToFreshpaint.attempted_status = false;
              if (origin === 'appointmentv2') {
                sendFreshpaintEvent(
                  'New Checkout - Payment Attempted',
                  dataToFreshpaint
                );
              }
              setLoadingEfectyButton(false);
            });
        }
      } catch (e) {
        // eslint-disable-next-line no-console
        console.error(e);
        setPreventModal(false);
      }
    })();
  };

  return (
    <>
      {preventModal && (
        <AlertModal
          data={outOfStockModal}
          modal={false}
          discardOption={false}
        />
      )}
      <div className={styles.titleContainer}>
        <p className={styles.title}>{titleEfecty}</p>
        <img
          className={styles.logo}
          width={67}
          src={efecty}
          alt="Efecty Logo"
        />
      </div>
      <div className={styles.container}>
        <p className={styles.text}>{descriptionEfecty}</p>
        <ul className={styles.list}>
          {stepsEfecty.map((step, index) => (
            <li key={step} className={styles.text}>
              <div className={styles.circle}>{index + 1}</div>
              <div className={styles.stepText}>{step}</div>
            </li>
          ))}
        </ul>
      </div>
      {disableButton && <p className={styles.text}>{capEfecty}</p>}
      <div className={styles.button}>
        <Button
          id="Check_Flow_GetReferenceOxxo"
          color="blue"
          disabled={disableButton}
          fullWidth
          isButton
          label={buttonEfecty}
          rel="noopener noreferrer"
          size="medium"
          variant="filled"
          loading={loadingEfectyButton}
          onClick={() => getEfectyReference()}
        />
      </div>
    </>
  );
};

export default FlowEfecty;
